module.exports = __webpack_public_path__ + "static/media/room_delete.c5076803.svg";